import script from "./AddParticipantsToNotarialAction.vue?vue&type=script&setup=true&lang=js"
export * from "./AddParticipantsToNotarialAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__